import api from './axios';

export const smtpApi = {
  getSettings() {
    return api.get('/smtp-settings').then(r => r.data);
  },

  saveSettings(data) {
    return api.post('/smtp-settings', data).then(r => r.data);
  },

  testConnection() {
    return api.post('/smtp-settings/test').then(r => r.data);
  },
};
